// extracted by extract-css-chunks-webpack-plugin
module.exports = {"row":"StripeForm-36337e58e8717648","column":"StripeForm-f6e79583ba769435"};